module.exports = __webpack_public_path__ + "img/15_1.683aed83.png";